export const DISCOVER_LIST_ATTEMPT = "DISCOVER_LIST_ATTEMPT";
export const DISCOVER_LIST_SUCCESS = "DISCOVER_LIST_SUCCESS";
export const DISCOVER_LIST_FAILED = "DISCOVER_LIST_FAILED";
////////////
export const DISCOVER_MORELIST_ATTEMPT = "DISCOVER_MORELIST_ATTEMPT";
export const DISCOVER_MORELIST_SUCCESS = "DISCOVER_MORELIST_SUCCESS";
export const DISCOVER_MORELIST_FAILED = "DISCOVER_MORELIST_FAILED";

